export default Object.freeze({
    EXPIRED: 'expired',
    PENDING: 'pending',
    REMOVED: 'removed',
    USED_UP: 'used_up',
    VALID: 'valid',
})



// WEBPACK FOOTER //
// ./src/Assets/components/Credits/consts/outward_facing_statuses.js